var Data = {

  // Get given data object in the Fraction.Data
  // Create it if it does not exists
  getDataObject: function(path){
    var objects = path.split('.');
    var return_object=Fraction.Data;
    var object, i;
    for (i=0;i < objects.length;i++){
      object = objects[i];
      if (!return_object[object]){
        return_object[object] = {};
      }
      return_object = return_object[object];
    }
    return return_object;
  },
  // Set data object in the Fraction.Data
  //  to the value provided
  setDataObject: function(path, value){
    var obj = this.getDataObject(path);
    obj = value;
    return obj;
  },
  // Remove the data object in the Fraction.Data
  deleteDataObject: function(path){
    /*var parts = path.split(".");
    var last = parts.pop();
    path = parts.join(".");
    delete obj[last];*/
    var obj = this.getDataObject(path);
    return obj;
  },

  // Saves out data that should be persisted across sessions
  // for this user.  Right now it uses cookies, later should
  // be jigsaw.
  savePersist: function(){
    var write_object = {};
    write_object = Fraction.Helpers.getDataObject('User.Persist');
    Fraction.Helpers.setItem(Fraction.Helpers.getUserEmailHash()+'_fraction_data', JSON.stringify(write_object));
  },

  // Loads persisted data.  Right now it is cookies, later should
  // be jigsaw
  loadPersist: function(){
    var load_object = Fraction.Helpers.getItem(Fraction.Helpers.getUserEmailHash()+'_fraction_data');
    if (load_object){
      try {
        load_object = JSON.parse(load_object);
        $.extend(true, Fraction.Helpers.getDataObject('User.Persist'), load_object);
      } catch(e){}
    }
    // Load up the redirect
    if (Fraction.Helpers.getItem('redirectAfterSignIn')){
      try {
        Fraction.redirectAfterSignIn = JSON.parse(Fraction.Helpers.getItem('redirectAfterSignIn'));
        Fraction.queryAfterSignIn = JSON.parse(Fraction.Helpers.getItem('queryAfterSignIn'));
      } catch(e){}
    }
  },

  // Resets user data
  resetPersist: function(){
    try {
      Fraction.Helpers.setItem(Fraction.Helpers.getUserEmailHash()+'_fraction_data', JSON.stringify({}));
      Fraction.Helpers.setItem('_default_fraction_data', JSON.stringify({}));
      Fraction.Reporter.addEvent('Reset User Data');
      window.location.reload();
    } catch (e){}
  },


  // http://www.w3schools.com/js/js_cookies.asp
  // Set a browser cookie
  setCookie: function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },

  removeCookie: function(cname){
    Fraction.Helpers.setCookie(cname, false, -1);
  },

  // Get a browser cookie
  getCookie: function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  },

  setItem: function(key, value) {
    try {
      return localStorage.setItem(key, value);
    } catch (e){}
  },

  getItem: function(key) {
    try {
      return localStorage.getItem(key);
    } catch (e){}
  },

  removeItem: function(key) {
    try {
      return localStorage.removeItem(key);
    } catch (e){}
  }

};

module.exports = Data;
